import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/api";

const SiteCtx = createContext({ settings: null, loading: true });
const SETTINGS_CACHE_KEY = "durga_site_settings";

const readCachedSettings = () => {
  try {
    const cached = sessionStorage.getItem(SETTINGS_CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
};

const cacheSettings = (settings) => {
  try {
    sessionStorage.setItem(SETTINGS_CACHE_KEY, JSON.stringify(settings));
  } catch {}
};

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(() => readCachedSettings());
  const [loading, setLoading] = useState(() => !readCachedSettings());

  useEffect(() => {
    let mounted = true;
    api.get("/settings").then((r) => {
      if (!mounted) return;
      setSettings(r.data);
      cacheSettings(r.data);
      setLoading(false);
      // Inject GA4 if configured
      const ga = r.data?.ga4_measurement_id;
      if (ga && !document.getElementById("ga4-script")) {
        const s = document.createElement("script");
        s.id = "ga4-script";
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`;
        document.head.appendChild(s);
        const inline = document.createElement("script");
        inline.text = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${ga}');`;
        document.head.appendChild(inline);
      }
      // GSC verification
      if (r.data?.gsc_verification && !document.querySelector('meta[name="google-site-verification"]')) {
        const m = document.createElement("meta");
        m.setAttribute("name", "google-site-verification");
        m.setAttribute("content", r.data.gsc_verification);
        document.head.appendChild(m);
      }
    }).catch(() => {
      if (!mounted) return;
      setLoading(false);
    });
    return () => { mounted = false; };
  }, []);

  return <SiteCtx.Provider value={{ settings, loading }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
